var _filter, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 88,
    viewBox: "0 0 144 88",
    width: 144,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "theme-light-a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 96,
    width: 152,
    x: 4,
    y: 14
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 3,
    result: "effect1_dropShadow_9973_64"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9973_64"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 4,
    result: "effect2_dropShadow_9973_64"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9973_64",
    mode: "normal",
    result: "effect2_dropShadow_9973_64"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9973_64",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "theme-light-b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h144v88h-144z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#theme-light-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h144v88h-144z",
    fill: "#f3f3f8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#theme-light-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 28c0-6.6274 5.3726-12 12-12h116v72h-128z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 16.5h115.5v71h-127v-59.5c0-6.3513 5.1487-11.5 11.5-11.5z",
    stroke: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e5e5eb"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 4,
    width: 20,
    x: 28,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    rx: 4,
    width: 72,
    x: 58,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 4,
    width: 20,
    x: 28,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    rx: 4,
    width: 56,
    x: 58,
    y: 61
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.237b3957157c9b047b604cb53304a0b2.svg";
export { ForwardRef as ReactComponent };